import { defineComponent } from "vue";
import FooterBanner from "./FooterBanner.vue";
export default defineComponent({
  components: {
    FooterBanner
  },
  setup() {
    return {};
  }
});